import React from 'react'

import { Segment } from '@sketch/components'
import { useFlag } from '@sketch/modules-common'

import { Container } from './WorkspaceMembershipsFilter.styles'

interface WorkspaceFilterProps<T> {
  activeFilter: T
  totalMemberships: number
  totalSSOMemberships: number
  totalPendingMemberships: number
  onChange: (value: T) => void
}

/*
 * WorkspaceFilter
 *
 * Renders the filter tabs for the Workspaces Memberships Table
 */
export const WorkspaceMembershipsFilter = <T,>({
  activeFilter,
  totalMemberships,
  totalSSOMemberships,
  totalPendingMemberships,
  onChange,
}: WorkspaceFilterProps<T>) => {
  const showPendingMemberships = useFlag('show-pending-memberships')

  return (
    <Container>
      <div onClick={() => onChange('all' as T)}>
        <Segment
          type="text"
          label={`All Workspaces (${totalMemberships})`}
          active={activeFilter === 'all'}
        />
      </div>

      <div onClick={() => onChange('sso' as T)}>
        <Segment
          type="text"
          label={`SSO (${totalSSOMemberships})`}
          active={activeFilter === 'sso'}
        />
      </div>

      {showPendingMemberships && (
        <div onClick={() => onChange('pending' as T)}>
          <Segment
            type="text"
            label={`Pending invites (${totalPendingMemberships})`}
            active={activeFilter === 'pending'}
          />
        </div>
      )}
    </Container>
  )
}
